import { combineReducers } from '@reduxjs/toolkit';
import country from './countrySlice';
import { auditLogReducer as auditLog } from '@ameroservices-platform/shared/ui-components/AuditLog';

const sharedReducers = combineReducers({
	auditLog,
	country,
});

export default sharedReducers;
